<table class="table" [ngClass]="{ loading: loading }">
  <thead class="table__header">
    <tr>
      <ng-container *ngFor="let headingComponent of tableHeadingComponents; let i = index">
        <ng-container *ngTemplateOutlet="headingComponent.template"></ng-container>
      </ng-container>
    </tr>
  </thead>
  <tbody class="table__body">
    <ng-content *ngIf="!loading" select="[air-table-body]"></ng-content>
    <ng-container *ngIf="loading">
      <tr *ngFor="let skeleton of [] | range: 3">
        <td *ngFor="let headingComponent of tableHeadingComponents; let i = index">
          <span>{{ "general.label.loading" | translate }}</span>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
